'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
/* eslint-disable @typescript-eslint/no-this-alias */
/* eslint-disable @typescript-eslint/ban-types */
var Guid_1 = require('./Guid');
var DownloadContext = /** @class */ (function () {
  function DownloadContext() {
  }
  return DownloadContext;
}());
var FileDownload = /** @class */ (function () {
  function FileDownload() {
  }
  FileDownload.download = function (url, callback) {
    var that = this;
    var iframe = document.createElement('iframe');
    var context = {
      token: Guid_1.default.NewGuid(),
      attempts: 60,
      callback: callback,
      iframe: iframe,
      error: null,
      isLoaded: false,
    };
    iframe.id = context.token;
    iframe.style.display = 'none';
    // iframe.style.height = '300px';
    // iframe.style.width = '400px';
    document.body.appendChild(iframe);
    iframe.onload = function a() {
      try {
        var doc = context.iframe.contentDocument ||
          (context.iframe.contentWindow != null ? context.iframe.contentWindow.document : window.document);
        var error = JSON.parse(doc.body.innerText);
        context.error = error ? error.message : null;
        context.isLoaded = true;
      }
      catch (_a) {
        // Intentionally Blank
      }
    };
    var url2 = url;
    if (url2.indexOf('?') < 0) {
      url2 += '?';
    }
    else {
      url2 += '&';
    }
    iframe.src = url2 + 'downloadToken=' + context.token;
    // document.body.insertAdjacentHTML('beforeend', `<iframe id='${context.token}' onload='alert(\'here\')' src='${iframe.src}'></iframe>`);
    that.checkCookie(context);
  };
  FileDownload.downloadBase64StringAsExcel = function (fileName, base64String) {
    var downloader = document.createElement('a');
    downloader.setAttribute('href', 'data:application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64,' + base64String);
    downloader.setAttribute('download', fileName);
    downloader.click();
  };
  FileDownload.downloadBase64StringAsFile = function (fileName, contentType, base64String) {
    var downloader = document.createElement('a');
    downloader.setAttribute('href', 'data:' + contentType + ';base64,' + base64String);
    downloader.setAttribute('download', fileName);
    downloader.click();
  };
  FileDownload.getCookie = function (name) {
    var parts = document.cookie.split(name + '=');
    var val = null;
    if (parts.length === 2) {
      var p1 = parts.pop() || '';
      val = p1.split(';').shift() || null;
    }
    return val;
  };
  FileDownload.expireCookie = function (name) {
    if (name == null) {
      return;
    }
    document.cookie = encodeURIComponent(name) + '=deleted; expires=' + new Date(0).toUTCString();
  };
  //    private setFormToken(): string {
  //        var guid:string = Guid.NewGuid();
  //        (document.getElementById('downloadToken')as any).value = guid;
  //        return guid;
  // }
  // Prevents double-submits by waiting for a cookie from the server.
  // private blockResubmit() {
  //    let that = this;
  //    let downloadToken = that.setFormToken();
  //    that.downloadTimer = window.setInterval(function () {
  //        let token = that.getCookie('downloadToken');
  //        if ((token == downloadToken) || (that.attempts == 0)) {
  //            that.unblockSubmit();
  //        }
  //        that.attempts--;
  //    }, 1000);
  // }
  // private unblockSubmit() {
  //    let that = this;
  //    window.clearInterval(that.downloadTimer);
  //    that.expireCookie('downloadToken');
  //    that.attempts = 30;
  // }
  FileDownload.checkCookie = function (context) {
    var that = this;
    var value = that.getCookie(context.token);
    if (value || context.isLoaded || context.attempts === 0) {
      if (context.attempts === 0) {
        context.error = 'Download timed out.';
      }
      that.expireCookie(context.token);
      document.body.removeChild(context.iframe);
      context.callback(context.error);
    }
    else {
      window.setTimeout(function () {
        context.attempts--;
        that.checkCookie(context);
      }, 500);
    }
  };
  return FileDownload;
}());
exports.default = FileDownload;
//# sourceMappingURL=FileDownload.js.map